export default __webpack_public_path__ + "static/media/HPSimplified_W_Rg.bfcff186.woff";